<template>
  <div class="flex w-full flex-row flex-wrap items-center justify-center py-5 md:flex-nowrap">
    <div
      v-for="footerContact in cmsStore.footer?.contacts"
      :key="footerContact.id"
      class="inline-flex flex-nowrap justify-center py-3 md:w-full"
    >
      <div class="flex flex-col items-center justify-center space-y-2">
        <UiImage
          v-if="footerContact.icon"
          :id="footerContact.id.toString()"
          class="size-10"
          :src="footerContact.icon.url"
          :alt="footerContact.icon.alt_text ?? footerContact.icon.name"
        />
        <UiHeading type="h3">{{ footerContact.title }}</UiHeading>
        <UiText size="sm" class="text-neutral-600">{{ footerContact.description }}</UiText>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useCmsStore } from '~/stores/cms/cmsStore';

const cmsStore = useCmsStore();
</script>
